import { css } from '@emotion/css';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Colors } from '../../styles/colors';

export const LocationsLoadingState = (): JSX.Element => {
  return (
    <SkeletonTheme baseColor={Colors.SURFACE} highlightColor="#e6ecf1">
      <div aria-busy="true" aria-label="Loading locations">
        {[0, 1, 2].map((index) => (
          <div key={index} className={index > 0 ? sectionMarginStyle : ''}>
            <Skeleton height={'11.5rem'} borderRadius={16} />
            <Skeleton
              className={marginStyle}
              height={'1.25rem'}
              width={'60%'}
              borderRadius={6}
            />
            <Skeleton height={'0.75rem'} width={'40%'} borderRadius={4} />
          </div>
        ))}
      </div>
    </SkeletonTheme>
  );
};

const marginStyle = css`
  margin-top: 1rem;
  margin-bottom: 0.5rem;
`;

const sectionMarginStyle = css`
  margin-top: 2rem;
`;
